import { Rate } from '@mortgage-pos/types'
import { loanTermToMonthsMap, rateCodesMap } from '@mortgage-pos/data'

const wholeDollars = new Intl.NumberFormat('en-US')

/**
 * The rate assumptions disclaimer shown in the rate card term tooltip: states
 * the loan terms, payment, and rate assumptions behind the displayed numbers.
 */
export function rateDisclosureTooltipText(rate: Rate): string {
  const termInMonths = loanTermToMonthsMap[rate?.term] ?? 0
  const termInYears = Math.round(termInMonths / 12)
  const termLabel = rateCodesMap[rate?.term] ?? `${termInYears}-year fixed`
  const asOfDate = new Date().toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  })
  const loanAmount = wholeDollars.format(Math.round(rate?.loanAmount ?? 0))
  const principalAndInterest = wholeDollars.format(
    Math.round(rate?.principleAndInterestPayment ?? 0)
  )

  return (
    `These rates, terms, and fees as of ${asOfDate} are subject to change ` +
    `daily without notice and are based on the following loan assumptions: ` +
    `(1) ${termLabel} fully amortizing loan, rate & term ${rate?.loanPurpose}, ` +
    `single family, primary residence; (2) ${termInMonths} monthly principal ` +
    `and interest payments of $${principalAndInterest}, an interest rate of ` +
    `${rate?.rate?.toFixed(3)}%, with the disclosed APR inclusive of lender ` +
    `credits, origination fee, and additional prepaid finance charges due at ` +
    `closing; (3) $${loanAmount} loan amount; (4) borrower credit score of ` +
    `${rate?.creditScore}+; (5) APR = Annual Percentage Rate; (6) ${rate?.lockPeriod ?? 30}-day lock ` +
    `period. Not available in all states, payment amounts shown do not ` +
    `include taxes and insurance, and the actual interest rate, APR and ` +
    `payment may vary based on the specific terms of the loan selected, ` +
    `verification of information, credit history, location, property type ` +
    `and other factors as determined by the lenders we work with. Terms and ` +
    `conditions apply.`
  )
}
